// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  state: __t.u8(),
  outcome: __t.u8(),
  xpEach: __t.u32().name("xp_each"),
  piles: __t.u32(),
  lost: __t.bool(),
  openedAt: __t.timestamp().name("opened_at"),
  deadlineAt: __t.timestamp().name("deadline_at"),
  givenAt: __t.option(__t.timestamp()).name("given_at"),
});
